import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import fetchRequest from 'src/network';
import { swalError, swalSuccess } from '../../sweetPopup';
import { logOutUser } from '../../constants';
import TncModal from './TncModal';
import OTPModal from './OTPModal';

const withVendorTnCCheck = (WrappedComponent) => {
    return function () {

        const user = useSelector((state) => state?.authReducer?.data?.user);

        const [visible, setVisible] = useState(
            user?.role === 'vendor' && !user?.tnc_accepted
        );

        const [showValidationForm, setShowValidationForm] = useState(false);

        const [msg, setMsg] = useState("");

        const [acceptTnC, setAcceptTnC] = useState(user?.tnc_accepted);

        const [otp, setOtp] = useState("");


        useEffect(() => {
            if (user?.role === "vendor" && !user?.tnc_accepted && !visible) {
                setVisible(true);
            }
        }, [user, visible]);

        const handleCloseTnC = () => {
            try {
                let body = {
                    "tnc_otp": Number(otp?.join(''))
                }
                fetchRequest?.post('/user/tnc', body)?.then((response) => {
                    if (response?.status_code === 200) {
                        swalSuccess(response?.message);
                        logOutUser();
                    } else {
                        swalError(response);
                    }
                })?.catch((error) => {
                    swalError(error);
                })
            } catch (error) {
                swalError(error);
            }
        }

        const handleVerify = () => {
            try {
                fetchRequest?.get('/user/tnc')?.then((response) => {
                    if (response?.status_code === 200) {
                        setMsg(response?.message);
                        setShowValidationForm(true);
                    } else {
                        swalError(response);
                    }
                })?.catch((error) => {
                    console.log("ERROR", error);
                    swalError(error);
                })
            } catch (error) {
                swalError(error);
            }
        }

        return (
            <>
                <WrappedComponent />
                {visible && (
                    <>
                        <TncModal
                            user={user}
                            acceptTnC={acceptTnC}
                            setAcceptTnC={setAcceptTnC}
                            handleVerify={handleVerify}
                        />
                        {showValidationForm && (
                            <OTPModal
                                msg={msg}
                                otp={otp}
                                setOtp={setOtp}
                                handleCloseTnC={handleCloseTnC}
                            />
                        )}
                    </>
                )}
            </>
        )
    }
}

export default withVendorTnCCheck;